import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { catalogClean, cleanSearchingCatalogsPaginated } from "../../app/actions/catalogActions";

import ReactTooltip from "react-tooltip";
import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import DisplayNameAndRole from "./DisplayNameAndRole";

const NavbarIconsCatalogs = ({ page }) => {
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

    const { isUserAuthenticated } = useSelector((state) => state.auth);

  const [activeIcon, setActiveIcon] = useState(null);

  const handleActiveIcon = (icon) => {
    
    if (icon === "new") {
      
      trackEvent({ component: "NewCatalogs", event: "NewCatalogs-Clicked" });
    } else if (icon === "list") {
      
      trackEvent({ component: "ListCatalogs", event: "ListCatalogs-Clicked" });
      dispatch(cleanSearchingCatalogsPaginated());
    }

    dispatch(catalogClean());
    setActiveIcon(icon);
  };

  const iconActiveStyle = (icon) => {
    if (activeIcon === icon) {
      return "icon-d-flex active";
    } else {
      return "icon-d-flex";
    }
  };

  return (
    <div className="d-flex justify-content-between align-items-center flex-nowrap gradient-custom-sky custom-nav-height">
      {isUserAuthenticated && (
        <DisplayNameAndRole />
      )}
      {page === "listCatalogs" && (
        <Link
          data-tip
          data-for="newCatalogsTip"
          to="/admin-catalog/new-catalog"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("new")}
        >
          <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "newCatalogs" && (
        <Link
          data-tip
          data-for="listCatalogsTip"
          to="/admin-catalog/"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("list")}
        >
          <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "editCatalogs" && (
        <div className="navbar-module-actions">
          <Link
            data-tip
            data-for="listCatalogsTip"
            to="/admin-catalog/"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("list")}
          >
            <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
          </Link>
          <Link
            data-tip
            data-for="newCatalogsTip"
            to="/admin-catalog/new-catalog"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("new")}
          >
            <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
          </Link>
        </div>
      )}

      <ReactTooltip id="newCatalogsTip" place="left" effect="solid">
        {t("admin-catalog.page.register")}
      </ReactTooltip>
      <ReactTooltip id="listCatalogsTip" place="left" effect="solid">
        {t("admin-catalog.page.list")}
      </ReactTooltip>
    </div>
  );
};

export default NavbarIconsCatalogs;
